import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { routes } from '@/app/routes'
import { useIsDesktop } from '@/ds'
import { usePaymentDrawerStore } from '@/features/payments/payment-drawer.store'

/** From 1024 px a drawer over the current screen, below that the full page; the page routes stay for deep links. */
export function usePaymentLauncher() {
  const navigate = useNavigate()
  const desktop = useIsDesktop()
  const show = usePaymentDrawerStore((st) => st.show)
  return useMemo(
    () => ({
      recordPayment: (leaseId?: string, amount?: number) => {
        if (desktop) return show({ leaseId, amount })
        const q = new URLSearchParams({ ...(leaseId ? { leaseId } : {}), ...(amount ? { amount: String(amount) } : {}) }).toString()
        navigate(`${routes.landlord.paymentNew}${q ? `?${q}` : ''}`)
      },
      payRent: (leaseId: string, amount?: number) => {
        if (desktop) return show({ leaseId, amount })
        navigate(`${routes.leasePay(leaseId)}${amount ? `?amount=${amount}` : ''}`)
      },
    }),
    [navigate, desktop, show],
  )
}
